const VERBOSE_PREFIX = '[session-manager]';

let verboseCache: boolean | null = null;

/** Memoized read of `?verbose=true` from the page URL. */
export function isVerbose(): boolean {
  if (verboseCache !== null) return verboseCache;
  try {
    verboseCache = new URLSearchParams(window.location.search).get('verbose') === 'true';
  } catch {
    verboseCache = false;
  }
  return verboseCache;
}

/** Emit a `console.debug` trace under the `[session-manager] [verbose]` prefix. No-op unless `?verbose=true`. */
export function vlog(...args: unknown[]): void {
  if (!isVerbose()) return;
  console.debug(VERBOSE_PREFIX, '[verbose]', ...args);
}
